import { auth } from '../../../services/firebase';

const normalizeText = (value) => String(value || '').trim();

export const getCaregiverDisplayName = (entry = {}) => {
  const currentUserLabel = normalizeText(
    auth.currentUser?.displayName
    || auth.currentUser?.email?.split('@')[0]
    || auth.currentUser?.email
    || ''
  );
  const caregiverRaw = normalizeText(
    entry.authorName
    || entry.loggedBy?.name
    || entry.loggedBy?.displayName
    || entry.capturedBy?.name
    || entry.originalData?.capturedBy?.name
    || entry.originalData?.authorName
    || entry.originalData?.loggedBy?.name
    || entry.originalData?.loggedBy?.displayName
    || entry.caregiverName
    || entry.loggedByUser
    || entry.author
    || entry.originalData?.author
    || ''
  );

  return caregiverRaw.toLowerCase() === 'you'
    ? currentUserLabel
    : caregiverRaw;
};

export const getCaregiverLabel = (entry = {}) => {
  const caregiverSource = getCaregiverDisplayName(entry);
  const caregiverParts = caregiverSource.split(/[\s@._-]+/).filter(Boolean);
  const caregiverInitials = caregiverParts.length >= 2
    ? `${caregiverParts[0][0]}${caregiverParts[caregiverParts.length - 1][0]}`.toUpperCase()
    : caregiverParts[0]?.slice(0, 2).toUpperCase() || '';

  return caregiverInitials || '';
};

export const getCaregiverActor = (
  entry = {},
  currentUserRole = null,
  currentUserId = null
) => {
  const label = getCaregiverDisplayName(entry);
  const initials = getCaregiverLabel(entry);
  const role = getResolvedCaregiverRole(entry, currentUserRole, currentUserId);

  if (!label && !initials && !role) {
    return null;
  }

  return {
    label,
    initials,
    role,
    shortLabel: initials || undefined,
  };
};

export const getTimelineLoggedByLabel = ({
  entry = {},
  displayName = '',
  initials = '',
} = {}) => (
  normalizeText(displayName) || getCaregiverDisplayName(entry) || normalizeText(initials)
);

export const getResolvedCaregiverRole = (
  entry = {},
  currentUserRole = null,
  currentUserId = null
) => {
  const explicitRole = entry?.loggedBy?.role
    || entry?.authorRole
    || entry?.userRole
    || entry?.loggedByRole
    || entry?.originalData?.loggedBy?.role
    || entry?.originalData?.authorRole
    || entry?.originalData?.userRole
    || entry?.originalData?.loggedByRole
    || null;
  if (explicitRole) {
    return explicitRole;
  }

  const entryUserId = entry?.loggedBy?.id
    || entry?.authorId
    || entry?.createdBy
    || entry?.userId
    || entry?.capturedBy?.id
    || entry?.originalData?.loggedBy?.id
    || entry?.originalData?.authorId
    || entry?.originalData?.createdBy
    || entry?.originalData?.userId
    || entry?.originalData?.capturedBy?.id
    || null;
  if (currentUserRole && currentUserId && entryUserId && String(entryUserId) === String(currentUserId)) {
    return currentUserRole;
  }

  return null;
};
